module.exports = __webpack_public_path__ + "img/icon_wpjdd.6c149e32.png";